import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import DataTranscriberValidationForm from '../../../Forms/DataTranscriberValidationForm/DataTranscriberValidationForm';
import { Button, Col, Modal, Row } from 'react-bootstrap';
import Api from '../../../../services/Api';
import { ApiResponse } from 'apisauce';
import { PromiseSerial } from '../../../../services/Utils/JSUtils';
import { initialKeywordValues } from '../../../Forms/Keywords/business-objects/common';
import { saveManagement } from '../redux-objects/actions';
import KeywordsController from '../../../Forms/Keywords/controller/KeywordsController';
import { openReport as keywordsOpenReport } from '../../Keywords/redux-objects/actions';
import InputSpinner from 'react-bootstrap-input-spinner'
import Step from '../../../shared/Step';
import * as urls from '../../../shared/urls';
import { eLocationUserType, IAppRouteLocation, IFormioValidationError, IKeywords, IReport, IWorkflowItemStep } from '../../../../common/sharedTypes';
import { toast } from 'react-toastify';
import { setKeywords, updateKeywords, saveSplitCase, openReport } from '../redux-objects/actions';
import '../management.css';
import CommentsButton from "../../../Comments/CommentsButton";
import LocationDataEntry from '../../Location/presentation/LocationEntry';
import { LocationWorkflowStepName } from '../../Location/presentation/config';
import { UserInfo } from '../../../Login/common/defaults';
import CreateFrontSheetButton from '../../../CreateFrontSheetButton/CreateFrontSheetButton';
import WindowPortal from '../../../FormIO/MappingComponent/lib/WindowPortal';
import MappingComponent from '../../../FormIO/MappingComponent';
import SplitCaseButton from '../../../SplitCaseButton/SplitCaseButton';
import UpdateKeywordsButton from '../../../shared/UpdateKeywordsButton/UpdateKeywordsButton';
import ViewAllButton from '../../../DocumentViewer/ViewAllButton';

interface IManageReportProps {
  openWorkflowItemStep: IWorkflowItemStep;
  workflowItemStepId: number;
  saveManagement?: (workflowItemStepId: number, data: any) => Promise<void>;
  history: any;
  location: any;
  setKeywords?: (keywords: IKeywords[]) => Promise<void>;
  updateKeywords?: (keywords: IKeywords) => Promise<void>;
  saveSplitCase?: (keywords: IKeywords[]) => Promise<void>;
  keywords?: IKeywords[];
  report?: IReport;
  openReport: (workflowItemStepId: number) => Promise<never>;
  webServiceURL: string;
  currentUser: UserInfo;
  keywordsOpenReport: (workflowItemStep: IWorkflowItemStep) => Promise<IWorkflowItemStep>;
}

interface IManageReportState {
  componentReady: boolean;
  showModal: boolean;
  keywordData: IKeywords;
  workflowItemStepId: number;
  canBeSplit: boolean;
  data: any;
  crashKey: string;
  documentId: string;
  report: IReport;

  // location entry stuff
  showLocationEntry: boolean;
  managedSteps?: IWorkflowItemStep[];
  locationStep?: IWorkflowItemStep;
  currentCrashId?: number;
  selectedItemId?: number;
  formIsReadOnly: boolean;
  enableContinue: boolean;
  locationEntryDataToSave: any;
  locationEntryValidations: IFormioValidationError[];
  validatingLocationData: boolean;

  mapConfig: any;
  showMap: boolean;
}

class ManageReport extends React.Component<
  IManageReportProps,
  IManageReportState
> {
  saving = false;
  manageForm = null;
  dataEntry: any;
  locWindowRef: any;
  mapElement: any;

  state: IManageReportState = {
    componentReady: false,
    showModal: false,
    keywordData: initialKeywordValues,
    workflowItemStepId: 0,
    data: null,
    canBeSplit: false,
    crashKey: '',
    documentId: '',
    report: null,
    showLocationEntry: false,
    managedSteps: [],
    locationStep: null,
    currentCrashId: 0,
    selectedItemId: 0,
    formIsReadOnly: false,
    enableContinue: true,
    locationEntryDataToSave: null,
    locationEntryValidations: [],
    validatingLocationData: false,
    mapConfig: null,
    showMap: false
  };

  loadComponentData = (): Promise<any> => {
    return Api.get(
      urls.GET_TRANSCRIBER_AND_KEYWORDS_DATA +
      '?workflowItemStepid=' +
      this.props.workflowItemStepId
    ).then((response: ApiResponse<any>) => {
      this.setComponentData(response);
      Promise.resolve();
    }
    );
  };

  setComponentData = (response: any) => {
    this.setState(
      {
        data: response.data,
        keywordData: response.data.caseKeywords,
        workflowItemStepId: response.data.workflowItemStepId,
        canBeSplit: response.data.canBeSplit,
        crashKey: response.data.caseKeywords.crashKey,
        documentId: response.data.caseKeywords.documentId,
        report: response.data.report,

        currentCrashId: response.data.report.crashReportId,
        selectedItemId: this.props.workflowItemStepId,
        managedSteps: response.data.activeSteps?.filter((x: IWorkflowItemStep) => x.statusId == 7),
        locationStep: response.data.locationStep
      },
    );
  };

  handleUpdateLocationData = (data: any) => {
    this.setState({ locationEntryDataToSave: data });
  }

  handleOpenMap = (mapConfig) => {
    // Reset showMap first so the MappingComponent (rendered with openNow) fully
    // remounts on every click. Otherwise, after the Map It popup is closed, showMap
    // remains true and re-clicking the button produces no state change, so the
    // popup can never be reopened without leaving and returning to the queue.
    this.setState({ showMap: false, mapConfig }, () => {
      this.setState({ showMap: true });
    });
  }

  handleSaveLocationEntry = (resolve: any = null) => {
    this.setContinue(false);
    let allDataFromEntry = { data: this.state.locationEntryDataToSave, currentItemId: this.props.workflowItemStepId }; // this.dataEntry.getDataToSave();
    let dataToSave = {
      spotMappedLocations: allDataFromEntry.data.spotMappedLocations,
      correctedData: allDataFromEntry.data.correctedData,
      workflowItemStepId: allDataFromEntry.currentItemId,
      currentUserId: this.props.currentUser.id,
    };

    Api.post(urls.SAVE_MANAGEMENT_LOCATION_DATA, dataToSave)
      .then((response: ApiResponse<any>) => {
        if (response.ok) {
          this.setComponentData(response);
        }
      })
      // TODO: Do we want to update keywords to onbase here like we do on location entry?
      // .then(this.handleUpdateKeywords).finally(() => {
      //   this.setContinue(true);
      // })
      .finally(() => {
        this.setContinue(true);
        this.setState({ showLocationEntry: false });
        window.location.reload();
      })
  };

  validateData = (resolve: any = null) => {
    let allDataFromEntry = { data: this.state.locationEntryDataToSave, currentItemId: this.props.workflowItemStepId }; // this.dataEntry.getDataToSave();
    let dataToSave = {
      spotMappedLocations: allDataFromEntry.data.spotMappedLocations,
      correctedData: allDataFromEntry.data.correctedData,
      workflowItemStepId: allDataFromEntry.currentItemId,
      currentUserId: this.props.currentUser.id,
    };
    this.setState({ validatingLocationData: true });
    Api.post(urls.VALIDATE_MANAGEMENT_LOCATION_DATA, dataToSave)
      .then((response: ApiResponse<any>) => {
        if (response.ok) {
          this.setState({ locationEntryValidations: response.data });
        }
      })
      .finally(() => {
        this.setContinue(true);
        this.setState({ validatingLocationData: false });
      })
  };

  handleClose = () => {
    this.setState({
      showModal: false,
    });
  };

  handleCloseLocationEntry = () => {
    this.setState({
      showLocationEntry: false,
    });
  };

  componentDidMount() {
    this.setState({ componentReady: false }, () => {
      PromiseSerial([
        this.loadComponentData,
        () => this.props.openReport(this.props.workflowItemStepId)
      ]).then((result) => {
        this.setState({ componentReady: true });
      });
    });
  }

  async handleSave(event: React.MouseEvent<HTMLElement>) {
    var formData = this.manageForm.getFormData();
    if (formData.data?.DateOfCrash?.trim() == '') {
      return;
    }

    this.saving = true;

    return new Promise<void>((resolve, reject) => {
      this.props
        .saveManagement(this.props.workflowItemStepId, formData)
        .then(() => {
          this.saving = false;
          toast.success('Saved');
        })
        .finally(() => resolve());
    });
  }

  removeReportFromManagement = () => {
    Api.post(
      urls.REMOVE_FROM_MANAGEMENT_QUEUE,
      this.props.workflowItemStepId
    ).then((response: ApiResponse<any>) => {
      if (response.ok) {
        this.backToManagementQueue();
      }
    });
  };

  backToManagementQueue = () => {
    let location: IAppRouteLocation = {
      pathname: '/ManagementQueue',
    };

    location.state = {
      workflowItemStepId: null,
    };

    this.props.history.push(location);
  };

  setContinue = (yesNo: boolean) => {
    this.setState({ enableContinue: yesNo });
  };

  onClosingClick = () => {
    this.setState({ showLocationEntry: false });
  };

  render() {
    const allButtons = (
      <React.Fragment>
        <div className='sidebar-button'>
          <Button
            variant='success'
            size='sm'
            onClick={(e) => this.handleSave(e)}
          >
            Save Report
          </Button>
        </div>
        <div className='sidebar-button'>
          <Button
            variant='success'
            size='sm'
            onClick={(e) => this.removeReportFromManagement()}
          >
            Send Report Back to Queue
          </Button>
        </div>
        <div className='sidebar-button'>
          <Button
            variant='secondary'
            size='sm'
            onClick={(e) => this.backToManagementQueue()}
          >
            Return to Management Queue
          </Button>
        </div>
      </React.Fragment>
    );

    return (
      <React.Fragment>
        {this.state.componentReady && (
          <React.Fragment>
            <Row>
              <ViewAllButton
                reportId={this.state.report.id}
                className='btn-sm mt-10 mr-10'
                text='View All Documents'
                managementMode={true}
              />
              <SplitCaseButton
                reportId={this.state.canBeSplit && this.props.openWorkflowItemStep?.workflowItem.reportId}
                disabled={!this.state.canBeSplit}
                openWorkflowItemStepId={this.state.canBeSplit && this.props.openWorkflowItemStep?.id}
                buttonText={this.state.canBeSplit ? 'Split Case' : 'Cannot be Split'}
                variant='primary'
                buttonClassName="btn-sm mt-10 mr-10 commentButtonManagement"
              />
              {'  '}
              <CreateFrontSheetButton
                reportId={this.state.report.id}
                onBeforeClick={() => this.handleSave(null)}
                className='mt-10 mr-2 commentButtonManagement'
              />
              <CommentsButton
                reportId={this.state.report.id}
                report={this.state.report}
                className='btn-sm mt-10 mr-10 commentButtonManagement'
                placement='right'
              />
              {'  '}
              {this.state.locationStep && (
                <React.Fragment>
                  <Button
                    variant='outline-primary'
                    onClick={(e) => this.handleOpenLocation()}
                    className='btn-sm mt-10 commentButtonManagement'
                  >Location Marking</Button>
                  {'  '}
                </React.Fragment>
              )}
            </Row>
            <hr />
            <Row><Col><b>Crash Key: {this.state.report.keywords.originalCrashKey}</b></Col></Row>
            {this.state.data && (
              <DataTranscriberValidationForm
                readOnly={false}
                data={JSON.parse(this.state.data.transcriberValidationFormData)}
                injectToSidebar={allButtons}
                ref={(el) => (this.manageForm = el)}
                formId={this.props.openWorkflowItemStep.workflowStep.formIoFormId}
              />
            )}
            {this.state.showLocationEntry && (
              <WindowPortal
                ref={(el) => {
                  this.locWindowRef = el;
                }}
                closeWindowPortal={this.onClosingClick}
                title="Location Entry"
                moveFromElement='.esri-layer-list'
                moveToElement='.mapLayerVisibilityController'
              >
                <LocationDataEntry
                  // ref={(comp) => {
                  //   this.dataEntry = comp;
                  // }}
                  currentQueueType={
                    this.state.locationStep.workflowStep.name == "Spot Mapping"
                      ? LocationWorkflowStepName.SpotMapping
                      : LocationWorkflowStepName.Review
                  }
                  setCrashId={(id) => this.setState({ currentCrashId: id })}
                  itemToEdit={this.state.selectedItemId}
                  webserviceUrl={this.props.webServiceURL.replace('/api/', '')}
                  readOnly={this.state.formIsReadOnly}
                  currentUserId={this.props.currentUser.id}
                  userTypeId={eLocationUserType.Administrator}
                  setContinue={this.setContinue} // check back on this one
                  workflowItemStepId={this.state.workflowItemStepId}
                  updateDataToSave={this.handleUpdateLocationData}
                  validationErrors={this.state.locationEntryValidations}
                  openMap={this.handleOpenMap}
                  validateData={this.validateData}
                  handleSaveLocationEntry={this.handleSaveLocationEntry}
                  validatingLocationData={this.state.validatingLocationData}
                />
              </WindowPortal>
            )}
            <div className="hide">
              {this.state.showMap && this.state.mapConfig && (
                <MappingComponent
                  mapConfig={this.state.mapConfig}
                  ref={(el) => (this.mapElement = el)}
                  openNow={true}
                />
              )}
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
  handleOpenLocation(): void {
    this.setState({ showLocationEntry: true });
  }
}

const mapStateToProps = (reduxState: any) => {
  return {
    webServiceURL: reduxState.Application.backendURL,
    currentUser: reduxState.Application.currentUser,
    keywords: reduxState.Management.keywords,
    openWorkflowItemStep: reduxState.Management.openWorkflowItemStep,
  };
};

const mapDispatchToProps = {
  saveManagement,
  setKeywords,
  updateKeywords,
  saveSplitCase,
  openReport,
  keywordsOpenReport,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ManageReport)
);
